import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import {
  Context,
  ReviewPlanSchema,
  StudyPlanTargets,
  Transitions
} from "../../types"
import { confirmRecommendedRestoreModal } from "../modals"
import { addLessonDrawerState, lessonDetailsDrawerState } from "../drawers"
import { setRedirectUrl } from "../../actions/setRedirectUrl"

// TODO: rename this to admin_view, update tests
export const reviewPlan: StateNodeConfig<
  Context,
  ReviewPlanSchema,
  Transitions,
  BaseActionObject
> = {
  // /Study Plans/{subject}/create
  entry: [
    assign((ctx, evt, meta) => {
      if (ctx.previousParentState !== "review_plan") {
        return setRedirectUrl(ctx, evt, meta, StudyPlanTargets.ReviewPlan)
      }
    }),
    assign((ctx, evt) => ({
      previousParentState: "review_plan",
      currentTarget:
        evt.type === "done.invoke.getRecommendedPlan"
          ? StudyPlanTargets.ViewRecommended
          : StudyPlanTargets.ReviewPlan,
      ...(ctx.currentTarget !== StudyPlanTargets.ViewRecommended && {
        recommendedStudyPlan: null
      })
    }))
  ],
  initial: "loading",
  states: {
    loading: {
      // If no current plan, fetch it.
      // This may happen if you got to the view plan page with browser navigation.
      always: [
        {
          cond: ctx => !ctx.publishedStudyPlan,
          target: "#StudyPlan.get_current_plan"
        },
        {
          target: "idle"
        }
      ]
    },
    idle: {
      on: {
        VIEW_RECOMMENDED_PLAN: {
          target: "#StudyPlan.get_recommended_plan_info_transition"
        },
        RESTORE_PLAN: {
          target: "restore_to_recommended_confirmation"
        },
        ADD_LESSON_TO_SECTION: {
          target: "add_lesson",
          actions: assign((_ctx, { sectionId }) => ({
            selectedSectionId: sectionId
          }))
        },
        /* Admins interactions */
        PLAN_SECOND_MODIFIER: {
          target: "#StudyPlan.start_plan",
          actions: assign((_ctx, { initSeconds }) => ({
            seconds: initSeconds
          }))
        },
        /* Adaptive Only */
        VIEW_DETAILS: {
          /* View details from draft plan or adaptive plan */
          target: "lesson_detail_view",
          actions: assign((_ctx, { sectionId, lessonId }) => ({
            selectedSectionId: sectionId,
            selectedLessonId: lessonId,
            lessonDetailViewModal: true
          }))
        },
        /* Default review_plan  - events for any review_plan idle state */
        EDIT: {
          target: "#StudyPlan.edit_plan",
          cond: ctx => !ctx.isReadOnly && !!ctx.studyPlan
        },

        /* Default review_plan  - events for any review_plan idle state */
        BUILD_STUDY_PLAN: {
          /* Edit a published plan */
          target: "#StudyPlan.edit_published_plan_transition"
        },
        SAVE: {
          // TODO: what if there is no existing plan?
          // Save plan state that checks if existing plan is there?
          target: "#StudyPlan.save_study_plan_transition"
        },
        CANCEL: [
          {
            target: "#StudyPlan.teacher_view",
            cond: ctx => ctx.selfRefScope.scope === "TEACHER",
            actions: assign<Context>({
              recommendedStudyPlan: null,
              currentTarget: StudyPlanTargets.TeacherView
            })
          },
          {
            // We don't need target as we're still in the review_plan state.
            cond: ctx => !!ctx.recommendedStudyPlan,
            actions: assign<Context>({
              recommendedStudyPlan: null,
              currentTarget: StudyPlanTargets.ReviewPlan
            })
          },
          {
            target: "#StudyPlan.study_plans_overview",
            actions: assign<Context>({
              publishedStudyPlan: null,
              seconds: null
            })
          }
        ]
      }
    },
    add_lesson: { ...addLessonDrawerState },
    lesson_detail_view: { ...lessonDetailsDrawerState },
    restore_to_recommended_confirmation: {
      ...confirmRecommendedRestoreModal
    }
  }
}
